import { Routes } from '@angular/router';

import { AuthGuard } from '@core/guards';
import { WorkspaceStateService } from '@core/services';
import { AuthLayoutComponent } from '@ui/layouts/auth-layout/auth-layout.component';
import { WorkspaceLayoutComponent } from '@ui/layouts/workspace-layout/workspace-layout.component';

export const routes: Routes = [
    {
        path: '',
        component: AuthLayoutComponent, 
        loadChildren: () => import('@features/auth/routes'),
    },
    {
        path: '',
        canActivate: [AuthGuard],
        component: WorkspaceLayoutComponent,
        providers: [WorkspaceStateService],
        children: [
            {
                path: 'account', 
                loadChildren: () => import('@features/account/routes'),
            },
            {
                path: 'profiles', 
                loadChildren: () => import('@features/profile/routes'),
            },
            {
                path: 'tenants', 
                loadChildren: () => import('@features/tenant/routes'),
            },
            {
                path: 'categories', 
                loadChildren: () => import('@features/category/routes'),
            },
            {
                path: 'assets', 
                loadChildren: () => import('@features/asset/routes'),
            },
            {
                path: 'tickets', 
                loadChildren: () => import('@features/ticket/routes'),
            },
            {
                path: 'users', 
                loadChildren: () => import('@features/user/routes'),
            },
        ]
    },
];
